import "./index.css";
import React from "react";
import { createRoot } from "react-dom/client";
import Root from "./Test/Root";
import "./Sale/sale.css";

createRoot(document.getElementById("root")).render(<Root />);
